export default __webpack_public_path__ + "static/media/navBanner.33878047.svg";